(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
function initLambertTransparentHeader(){
 const header=document.querySelector('[data-lb-transparent-header]');
 if(!header || header.dataset.scrollReady)return;
 header.dataset.scrollReady='1';
 const update=()=>header.classList.toggle('is-scrolled',window.scrollY>24);
 update();
 window.addEventListener('scroll',update,{passive:true});
 window.addEventListener('pageshow',update);
}
initLambertTransparentHeader();
document.addEventListener('shopify:section:load',initLambertTransparentHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lambert-immersive-hero"] && !Shopify.designMode) return;
  try {
    
function initLambertHero(){document.querySelectorAll('.lb-immersive').forEach(hero=>{if(hero.dataset.ready)return;hero.dataset.ready='1';const track=hero.querySelector('.lb-immersive-track');const slides=track.children.length;const output=hero.querySelector('output');const current=()=>Math.round(track.scrollLeft/Math.max(track.clientWidth,1));hero.querySelectorAll('[data-lb-step]').forEach(button=>button.addEventListener('click',()=>{const next=(current()+Number(button.dataset.lbStep)+slides)%slides;track.scrollTo({left:next*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));track.addEventListener('scroll',()=>{if(output)output.textContent=`${current()+1} / ${slides}`;},{passive:true});});}initLambertHero();document.addEventListener('shopify:section:load',initLambertHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
